// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/images/icon/icon_up_arr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/images/icon/icon_down_arr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/assets/images/icon/icon_right_arr.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/assets/images/icon/icon_right_arr_2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/src/assets/images/icon/icon_kakao.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/src/assets/images/icon/icon_naver.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/src/assets/images/icon/icon_apple.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/src/assets/images/icon/icon_user.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/src/assets/images/icon/icon_round_kakao.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("/src/assets/images/icon/icon_round_naver.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("/src/assets/images/icon/icon_round_apple.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("/src/assets/images/icon/icon_complete.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("/src/assets/images/icon/icon_fail.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("/src/assets/images/icon/icon_menu1_1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("/src/assets/images/icon/icon_menu1_2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("/src/assets/images/icon/icon_menu1_3.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("/src/assets/images/icon/icon_menu2_1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("/src/assets/images/icon/icon_menu2_2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("/src/assets/images/icon/icon_menu2_3.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("/src/assets/images/icon/icon_menu2_4.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("/src/assets/images/icon/icon_menu3_1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("/src/assets/images/icon/icon_menu3_2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("/src/assets/images/icon/icon_menu3_3.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("/src/assets/images/icon/icon_menu4_1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("/src/assets/images/icon/icon_community_category1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("/src/assets/images/icon/icon_community_category2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("/src/assets/images/icon/icon_community_category3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("/src/assets/images/icon/icon_community_category4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("/src/assets/images/icon/icon_community_category5.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("/src/assets/images/icon/icon_community_category6.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* v1.0 mobile */
/* reset */
* {
  margin: 0;
  padding: 0;
  border: 0;
  box-sizing: border-box;
}
html {
  font-size: 62.5%;
  line-height: 1;
  font-family: "ptd-v";
  letter-spacing: -0.03rem;
}
body {
  font-size: 1.6rem;
}
li {
  list-style: none;
}
a {
  color: #000;
  text-decoration: none;
}
button {
  padding: 0;
  border: 0;
  background-color: transparent;
  color: #000;
}
button,
input,
textarea,
select {
  font-weight: inherit;
  font-size: inherit;
  line-height: inherit;
  font-family: inherit;
  letter-spacing: inherit;
  -webkit-tap-highlight-color: transparent;
}
input:focus,
textarea:focus,
select:focus {
  outline: none;
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 100rem transparent inset;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}
textarea {
  resize: none;
  -webkit-tap-highlight-color: transparent;
}
label {
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
table {
  border-spacing: 0;
  border-collapse: collapse;
}
th,
td {
  position: relative;
}

/* common */
/* form */
input[type="text"],
input[type="email"],
input[type="password"],
input[type="tel"],
input[type="tel"],
input[type="search"],
input[type="datetime-local"],
input[type="date"],
input[type="month"],
input[type="time"],
input[type="url"],
input.tf {
  height: 2.5rem;
  /* font-weight: 500; */
  /* font-size: 1.7rem; */
  color: #000;
  /* IOS에서 input border-radius, 그림자 해제 */
  -webkit-appearance: none;
  -webkit-border-radius: 0;
}
input::placeholder {
  color: #919191;
}
input:disabled {
  background-color: #fff;
  /* IOS에서 input disabled의 기본값 해제 */
  opacity: 1;
  -webkit-text-fill-color: #2f2f2f;
  color: #2f2f2f;
}
input:disabled.type2 {
  font-weight: 400 !important;
  color: #919191;
}
input[type="button"],
input[type="submit"] {
  cursor: pointer;
}

input[type="file"] {
  position: absolute;
  overflow: hidden;
  width: 0;
  height: 0;
  padding: 0;
  border: 0;
}
input[type="checkbox"],
input[type="radio"] {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  cursor: pointer;
}
input[type="checkbox"]:checked,
input[type="radio"]:checked {
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  cursor: pointer;
}
select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;
}

/* button */
button {
  cursor: pointer;
}

/* icon */
i {
  display: inline-block;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

/* arrow */
.ico-up-arr {
  width: 2rem;
  height: 2rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.ico-down-arr {
  width: 2rem;
  height: 2rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.ico-right-arr {
  width: 2rem;
  height: 2rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.ico-right-arr-2 {
  width: 1.8rem;
  height: 1.8rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

/* social join btn */
.ico-kakao {
  width: 2.5rem;
  height: 2.5rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.ico-naver {
  width: 2.5rem;
  height: 2.5rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.ico-apple {
  width: 2.5rem;
  height: 2.5rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.ico-user {
  width: 2.5rem;
  height: 2.5rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.ico-round-kakao {
  width: 1.9rem;
  height: 1.9rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.ico-round-naver {
  width: 1.9rem;
  height: 1.9rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.ico-round-apple {
  width: 1.9rem;
  height: 1.9rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

/* complete */
.ico-complete {
  width: 5rem;
  height: 5rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.ico-fail {
  width: 4rem;
  height: 4rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
/* menu */
.ico-menu {
  width: 3rem;
  height: 3rem;
}
.menu1-1 .ico-menu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.menu1-2 .ico-menu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}
.menu1-3 .ico-menu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}
.menu2-1 .ico-menu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}
.menu2-2 .ico-menu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}
.menu2-3 .ico-menu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}
.menu2-4 .ico-menu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.menu3-1 .ico-menu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
.menu3-2 .ico-menu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
.menu3-3 .ico-menu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}
.menu4-1 .ico-menu {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}

/* community category */
.ico-community-category {
  width: 7.5rem;
  height: 7.5rem;
}
.category1 .ico-community-category {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.category2 .ico-community-category {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}
.category3 .ico-community-category {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}
.category4 .ico-community-category {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}
.category5 .ico-community-category {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
}
.category6 .ico-community-category {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
}

/*  */
.sr-only {
  position: absolute;
  width: 0.1rem;
  height: 0.1rem;
  padding: 0;
  margin: -0.1rem;
  border: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  clip-path: polygon(0 0, 0 0, 0 0);
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.justify-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.items-center {
  display: flex;
  align-items: center;
}
.relative {
  position: relative;
}

/* gap */
.gap0 {
  gap: 0 !important;
}
.gap2 {
  gap: 0.2rem !important;
}
.gap4 {
  gap: 0.4rem !important;
}
.gap5 {
  gap: 0.5rem !important;
}
.gap6 {
  gap: 0.6rem !important;
}
.gap8 {
  gap: 0.8rem !important;
}
.gap10 {
  gap: 1rem !important;
}
.gap12 {
  gap: 1.2rem !important;
}
.gap14 {
  gap: 1.4rem !important;
}
.gap15 {
  gap: 1.5rem !important;
}
.gap16 {
  gap: 1.6rem !important;
}
.gap18 {
  gap: 1.8rem !important;
}
.gap20 {
  gap: 2rem !important;
}
.gap22 {
  gap: 2.2rem !important;
}
.gap24 {
  gap: 2.4rem !important;
}
.gap25 {
  gap: 2.5rem !important;
}
.gap26 {
  gap: 2.6rem !important;
}
.gap28 {
  gap: 2.8rem !important;
}
.gap30 {
  gap: 3rem !important;
}
.gap32 {
  gap: 3.2rem !important;
}
.gap34 {
  gap: 3.4rem !important;
}
.gap35 {
  gap: 3.5rem !important;
}
.gap36 {
  gap: 3.6rem !important;
}
.gap38 {
  gap: 3.8rem !important;
}
.gap40 {
  gap: 4rem !important;
}
.gap42 {
  gap: 4.2rem !important;
}
.gap42 {
  gap: 4.2rem !important;
}
.gap44 {
  gap: 4.4rem !important;
}
.gap45 {
  gap: 4.5rem !important;
}
.gap46 {
  gap: 4.6rem !important;
}
.gap48 {
  gap: 4.8rem !important;
}
.gap50 {
  gap: 5rem !important;
}
.gap52 {
  gap: 5.2rem !important;
}
.gap54 {
  gap: 5.4rem !important;
}
.gap55 {
  gap: 5.5rem !important;
}
.gap56 {
  gap: 5.6rem !important;
}
.gap58 {
  gap: 5.8rem !important;
}
.gap60 {
  gap: 6rem !important;
}
.gap62 {
  gap: 6.2rem !important;
}
.gap64 {
  gap: 6.4rem !important;
}
.gap65 {
  gap: 6.5rem !important;
}
.gap65 {
  gap: 6.5rem !important;
}
.gap66 {
  gap: 6.6rem !important;
}
.gap68 {
  gap: 6.8rem !important;
}
.gap70 {
  gap: 7rem !important;
}
.gap72 {
  gap: 7.2rem !important;
}
.gap74 {
  gap: 7.4rem !important;
}
.gap74 {
  gap: 7.4rem !important;
}
.gap75 {
  gap: 7.5rem !important;
}
.gap76 {
  gap: 7.6rem !important;
}
.gap78 {
  gap: 7.8rem !important;
}
.gap80 {
  gap: 8rem !important;
}
.gap82 {
  gap: 8.2rem !important;
}
.gap84 {
  gap: 8.4rem !important;
}
.gap85 {
  gap: 8.5rem !important;
}
.gap86 {
  gap: 8.6rem !important;
}
.gap88 {
  gap: 8.8rem !important;
}
.gap90 {
  gap: 9rem !important;
}
.gap92 {
  gap: 9.2rem !important;
}
.gap94 {
  gap: 9.4rem !important;
}
.gap95 {
  gap: 9.5rem !important;
}
.gap96 {
  gap: 9.6rem !important;
}
.gap98 {
  gap: 9.8rem !important;
}
.gap100 {
  gap: 10rem !important;
}

/* margin */
.mt0 {
  margin-top: 0 !important;
}
.mt2 {
  margin-top: 0.2rem !important;
}
.mt4 {
  margin-top: 0.4rem !important;
}
.mt5 {
  margin-top: 0.5rem !important;
}
.mt6 {
  margin-top: 0.6rem !important;
}
.mt8 {
  margin-top: 0.8rem !important;
}
.mt10 {
  margin-top: 1rem !important;
}
.mt12 {
  margin-top: 1.2rem !important;
}
.mt14 {
  margin-top: 1.4rem !important;
}
.mt15 {
  margin-top: 1.5rem !important;
}
.mt16 {
  margin-top: 1.6rem !important;
}
.mt18 {
  margin-top: 1.8rem !important;
}
.mt20 {
  margin-top: 2rem !important;
}
.mt22 {
  margin-top: 2.2rem !important;
}
.mt24 {
  margin-top: 2.4rem !important;
}
.mt25 {
  margin-top: 2.5rem !important;
}
.mt26 {
  margin-top: 2.6rem !important;
}
.mt28 {
  margin-top: 2.8rem !important;
}
.mt30 {
  margin-top: 3rem !important;
}
.mt32 {
  margin-top: 3.2rem !important;
}
.mt34 {
  margin-top: 3.4rem !important;
}
.mt35 {
  margin-top: 3.5rem !important;
}
.mt36 {
  margin-top: 3.6rem !important;
}
.mt38 {
  margin-top: 3.8rem !important;
}
.mt40 {
  margin-top: 4rem !important;
}
.mt42 {
  margin-top: 4.2rem !important;
}
.mt42 {
  margin-top: 4.2rem !important;
}
.mt44 {
  margin-top: 4.4rem !important;
}
.mt45 {
  margin-top: 4.5rem !important;
}
.mt46 {
  margin-top: 4.6rem !important;
}
.mt48 {
  margin-top: 4.8rem !important;
}
.mt50 {
  margin-top: 5rem !important;
}
.mt52 {
  margin-top: 5.2rem !important;
}
.mt54 {
  margin-top: 5.4rem !important;
}
.mt55 {
  margin-top: 5.5rem !important;
}
.mt56 {
  margin-top: 5.6rem !important;
}
.mt58 {
  margin-top: 5.8rem !important;
}
.mt60 {
  margin-top: 6rem !important;
}
.mt62 {
  margin-top: 6.2rem !important;
}
.mt64 {
  margin-top: 6.4rem !important;
}
.mt65 {
  margin-top: 6.5rem !important;
}
.mt65 {
  margin-top: 6.5rem !important;
}
.mt66 {
  margin-top: 6.6rem !important;
}
.mt68 {
  margin-top: 6.8rem !important;
}
.mt70 {
  margin-top: 7rem !important;
}
.mt72 {
  margin-top: 7.2rem !important;
}
.mt74 {
  margin-top: 7.4rem !important;
}
.mt74 {
  margin-top: 7.4rem !important;
}
.mt75 {
  margin-top: 7.5rem !important;
}
.mt76 {
  margin-top: 7.6rem !important;
}
.mt78 {
  margin-top: 7.8rem !important;
}
.mt80 {
  margin-top: 8rem !important;
}
.mt82 {
  margin-top: 8.2rem !important;
}
.mt84 {
  margin-top: 8.4rem !important;
}
.mt85 {
  margin-top: 8.5rem !important;
}
.mt86 {
  margin-top: 8.6rem !important;
}
.mt88 {
  margin-top: 8.8rem !important;
}
.mt90 {
  margin-top: 9rem !important;
}
.mt92 {
  margin-top: 9.2rem !important;
}
.mt94 {
  margin-top: 9.4rem !important;
}
.mt95 {
  margin-top: 9.5rem !important;
}
.mt96 {
  margin-top: 9.6rem !important;
}
.mt98 {
  margin-top: 9.8rem !important;
}
.mt100 {
  margin-top: 10rem !important;
}

.mb0 {
  margin-bottom: 0 !important;
}
.mb2 {
  margin-bottom: 0.2rem !important;
}
.mb4 {
  margin-bottom: 0.4rem !important;
}
.mb5 {
  margin-bottom: 0.5rem !important;
}
.mb6 {
  margin-bottom: 0.6rem !important;
}
.mb8 {
  margin-bottom: 0.8rem !important;
}
.mb10 {
  margin-bottom: 1rem !important;
}
.mb12 {
  margin-bottom: 1.2rem !important;
}
.mb14 {
  margin-bottom: 1.4rem !important;
}
.mb15 {
  margin-bottom: 1.5rem !important;
}
.mb16 {
  margin-bottom: 1.6rem !important;
}
.mb18 {
  margin-bottom: 1.8rem !important;
}
.mb20 {
  margin-bottom: 2rem !important;
}
.mb22 {
  margin-bottom: 2.2rem !important;
}
.mb24 {
  margin-bottom: 2.4rem !important;
}
.mb25 {
  margin-bottom: 2.5rem !important;
}
.mb26 {
  margin-bottom: 2.6rem !important;
}
.mb28 {
  margin-bottom: 2.8rem !important;
}
.mb30 {
  margin-bottom: 3rem !important;
}
.mb32 {
  margin-bottom: 3.2rem !important;
}
.mb34 {
  margin-bottom: 3.4rem !important;
}
.mb35 {
  margin-bottom: 3.5rem !important;
}
.mb36 {
  margin-bottom: 3.6rem !important;
}
.mb38 {
  margin-bottom: 3.8rem !important;
}
.mb40 {
  margin-bottom: 4rem !important;
}
.mb42 {
  margin-bottom: 4.2rem !important;
}
.mb42 {
  margin-bottom: 4.2rem !important;
}
.mb44 {
  margin-bottom: 4.4rem !important;
}
.mb45 {
  margin-bottom: 4.5rem !important;
}
.mb46 {
  margin-bottom: 4.6rem !important;
}
.mb48 {
  margin-bottom: 4.8rem !important;
}
.mb50 {
  margin-bottom: 5rem !important;
}
.mb52 {
  margin-bottom: 5.2rem !important;
}
.mb54 {
  margin-bottom: 5.4rem !important;
}
.mb55 {
  margin-bottom: 5.5rem !important;
}
.mb56 {
  margin-bottom: 5.6rem !important;
}
.mb58 {
  margin-bottom: 5.8rem !important;
}
.mb60 {
  margin-bottom: 6rem !important;
}
.mb62 {
  margin-bottom: 6.2rem !important;
}
.mb64 {
  margin-bottom: 6.4rem !important;
}
.mb65 {
  margin-bottom: 6.5rem !important;
}
.mb65 {
  margin-bottom: 6.5rem !important;
}
.mb66 {
  margin-bottom: 6.6rem !important;
}
.mb68 {
  margin-bottom: 6.8rem !important;
}
.mb70 {
  margin-bottom: 7rem !important;
}
.mb72 {
  margin-bottom: 7.2rem !important;
}
.mb74 {
  margin-bottom: 7.4rem !important;
}
.mb74 {
  margin-bottom: 7.4rem !important;
}
.mb75 {
  margin-bottom: 7.5rem !important;
}
.mb76 {
  margin-bottom: 7.6rem !important;
}
.mb78 {
  margin-bottom: 7.8rem !important;
}
.mb80 {
  margin-bottom: 8rem !important;
}
.mb82 {
  margin-bottom: 8.2rem !important;
}
.mb84 {
  margin-bottom: 8.4rem !important;
}
.mb85 {
  margin-bottom: 8.5rem !important;
}
.mb86 {
  margin-bottom: 8.6rem !important;
}
.mb88 {
  margin-bottom: 8.8rem !important;
}
.mb90 {
  margin-bottom: 9rem !important;
}
.mb92 {
  margin-bottom: 9.2rem !important;
}
.mb94 {
  margin-bottom: 9.4rem !important;
}
.mb95 {
  margin-bottom: 9.5rem !important;
}
.mb96 {
  margin-bottom: 9.6rem !important;
}
.mb98 {
  margin-bottom: 9.8rem !important;
}
.mb100 {
  margin-bottom: 10rem !important;
}

/* padding */
.p0 {
  padding: 0 !important;
}

.pt0 {
  padding-top: 0 !important;
}
.pt2 {
  padding-top: 0.2rem !important;
}
.pt4 {
  padding-top: 0.4rem !important;
}
.pt5 {
  padding-top: 0.5rem !important;
}
.pt6 {
  padding-top: 0.6rem !important;
}
.pt8 {
  padding-top: 0.8rem !important;
}
.pt10 {
  padding-top: 1rem !important;
}
.pt12 {
  padding-top: 1.2rem !important;
}
.pt14 {
  padding-top: 1.4rem !important;
}
.pt15 {
  padding-top: 1.5rem !important;
}
.pt16 {
  padding-top: 1.6rem !important;
}
.pt18 {
  padding-top: 1.8rem !important;
}
.pt20 {
  padding-top: 2rem !important;
}
.pt22 {
  padding-top: 2.2rem !important;
}
.pt24 {
  padding-top: 2.4rem !important;
}
.pt25 {
  padding-top: 2.5rem !important;
}
.pt26 {
  padding-top: 2.6rem !important;
}
.pt28 {
  padding-top: 2.8rem !important;
}
.pt30 {
  padding-top: 3rem !important;
}
.pt32 {
  padding-top: 3.2rem !important;
}
.pt34 {
  padding-top: 3.4rem !important;
}
.pt35 {
  padding-top: 3.5rem !important;
}
.pt36 {
  padding-top: 3.6rem !important;
}
.pt38 {
  padding-top: 3.8rem !important;
}
.pt40 {
  padding-top: 4rem !important;
}
.pt42 {
  padding-top: 4.2rem !important;
}
.pt42 {
  padding-top: 4.2rem !important;
}
.pt44 {
  padding-top: 4.4rem !important;
}
.pt45 {
  padding-top: 4.5rem !important;
}
.pt46 {
  padding-top: 4.6rem !important;
}
.pt48 {
  padding-top: 4.8rem !important;
}
.pt50 {
  padding-top: 5rem !important;
}
.pt52 {
  padding-top: 5.2rem !important;
}
.pt54 {
  padding-top: 5.4rem !important;
}
.pt55 {
  padding-top: 5.5rem !important;
}
.pt56 {
  padding-top: 5.6rem !important;
}
.pt58 {
  padding-top: 5.8rem !important;
}
.pt60 {
  padding-top: 6rem !important;
}
.pt62 {
  padding-top: 6.2rem !important;
}
.pt64 {
  padding-top: 6.4rem !important;
}
.pt65 {
  padding-top: 6.5rem !important;
}
.pt65 {
  padding-top: 6.5rem !important;
}
.pt66 {
  padding-top: 6.6rem !important;
}
.pt68 {
  padding-top: 6.8rem !important;
}
.pt70 {
  padding-top: 7rem !important;
}
.pt72 {
  padding-top: 7.2rem !important;
}
.pt74 {
  padding-top: 7.4rem !important;
}
.pt74 {
  padding-top: 7.4rem !important;
}
.pt75 {
  padding-top: 7.5rem !important;
}
.pt76 {
  padding-top: 7.6rem !important;
}
.pt78 {
  padding-top: 7.8rem !important;
}
.pt80 {
  padding-top: 8rem !important;
}
.pt82 {
  padding-top: 8.2rem !important;
}
.pt84 {
  padding-top: 8.4rem !important;
}
.pt85 {
  padding-top: 8.5rem !important;
}
.pt86 {
  padding-top: 8.6rem !important;
}
.pt88 {
  padding-top: 8.8rem !important;
}
.pt90 {
  padding-top: 9rem !important;
}
.pt92 {
  padding-top: 9.2rem !important;
}
.pt94 {
  padding-top: 9.4rem !important;
}
.pt95 {
  padding-top: 9.5rem !important;
}
.pt96 {
  padding-top: 9.6rem !important;
}
.pt98 {
  padding-top: 9.8rem !important;
}
.pt100 {
  padding-top: 10rem !important;
}

.pb0 {
  padding-bottom: 0 !important;
}
.pb2 {
  padding-bottom: 0.2rem !important;
}
.pb4 {
  padding-bottom: 0.4rem !important;
}
.pb5 {
  padding-bottom: 0.5rem !important;
}
.pb6 {
  padding-bottom: 0.6rem !important;
}
.pb8 {
  padding-bottom: 0.8rem !important;
}
.pb10 {
  padding-bottom: 1rem !important;
}
.pb12 {
  padding-bottom: 1.2rem !important;
}
.pb14 {
  padding-bottom: 1.4rem !important;
}
.pb15 {
  padding-bottom: 1.5rem !important;
}
.pb16 {
  padding-bottom: 1.6rem !important;
}
.pb18 {
  padding-bottom: 1.8rem !important;
}
.pb20 {
  padding-bottom: 2rem !important;
}
.pb22 {
  padding-bottom: 2.2rem !important;
}
.pb24 {
  padding-bottom: 2.4rem !important;
}
.pb25 {
  padding-bottom: 2.5rem !important;
}
.pb26 {
  padding-bottom: 2.6rem !important;
}
.pb28 {
  padding-bottom: 2.8rem !important;
}
.pb30 {
  padding-bottom: 3rem !important;
}
.pb32 {
  padding-bottom: 3.2rem !important;
}
.pb34 {
  padding-bottom: 3.4rem !important;
}
.pb35 {
  padding-bottom: 3.5rem !important;
}
.pb36 {
  padding-bottom: 3.6rem !important;
}
.pb38 {
  padding-bottom: 3.8rem !important;
}
.pb40 {
  padding-bottom: 4rem !important;
}
.pb42 {
  padding-bottom: 4.2rem !important;
}
.pb42 {
  padding-bottom: 4.2rem !important;
}
.pb44 {
  padding-bottom: 4.4rem !important;
}
.pb45 {
  padding-bottom: 4.5rem !important;
}
.pb46 {
  padding-bottom: 4.6rem !important;
}
.pb48 {
  padding-bottom: 4.8rem !important;
}
.pb50 {
  padding-bottom: 5rem !important;
}
.pb52 {
  padding-bottom: 5.2rem !important;
}
.pb54 {
  padding-bottom: 5.4rem !important;
}
.pb55 {
  padding-bottom: 5.5rem !important;
}
.pb56 {
  padding-bottom: 5.6rem !important;
}
.pb58 {
  padding-bottom: 5.8rem !important;
}
.pb60 {
  padding-bottom: 6rem !important;
}
.pb62 {
  padding-bottom: 6.2rem !important;
}
.pb64 {
  padding-bottom: 6.4rem !important;
}
.pb65 {
  padding-bottom: 6.5rem !important;
}
.pb65 {
  padding-bottom: 6.5rem !important;
}
.pb66 {
  padding-bottom: 6.6rem !important;
}
.pb68 {
  padding-bottom: 6.8rem !important;
}
.pb70 {
  padding-bottom: 7rem !important;
}
.pb72 {
  padding-bottom: 7.2rem !important;
}
.pb74 {
  padding-bottom: 7.4rem !important;
}
.pb74 {
  padding-bottom: 7.4rem !important;
}
.pb75 {
  padding-bottom: 7.5rem !important;
}
.pb76 {
  padding-bottom: 7.6rem !important;
}
.pb78 {
  padding-bottom: 7.8rem !important;
}
.pb80 {
  padding-bottom: 8rem !important;
}
.pb82 {
  padding-bottom: 8.2rem !important;
}
.pb84 {
  padding-bottom: 8.4rem !important;
}
.pb85 {
  padding-bottom: 8.5rem !important;
}
.pb86 {
  padding-bottom: 8.6rem !important;
}
.pb88 {
  padding-bottom: 8.8rem !important;
}
.pb90 {
  padding-bottom: 9rem !important;
}
.pb92 {
  padding-bottom: 9.2rem !important;
}
.pb94 {
  padding-bottom: 9.4rem !important;
}
.pb95 {
  padding-bottom: 9.5rem !important;
}
.pb96 {
  padding-bottom: 9.6rem !important;
}
.pb98 {
  padding-bottom: 9.8rem !important;
}
.pb100 {
  padding-bottom: 10rem !important;
}
.pb120 {
  padding-bottom: 12rem !important;
}

/* heading tag */
h2 {
  font-weight: 500;
  font-size: 2rem;
  line-height: 1.35;
}
h2.type2 {
  font-size: 1.8rem;
}
h3 {
  font-weight: 400;
  font-size: 1.6rem;
}
h3.type2 {
  font-weight: 500;
  font-size: 1.8rem;
}
h4 {
  font-weight: 400;
  font-size: 1.5rem;
  color: #555;
}
.h2 {
  font-weight: 500;
  font-size: 2rem;
  line-height: 1.35;
}
.h3 {
  font-weight: 500;
  font-size: 1.8rem;
}
.h4 {
  font-weight: 400;
  font-size: 1.5rem;
  color: #555;
}

/* point color */
.main-color {
  color: #00b1d8 !important;
}
.sub-color1 {
  color: #008ead;
}
.sub-color2 {
  color: #93d0de;
}
.sub-color3 {
  color: #8dd9f9;
}
.sub-color4 {
  color: #dbf4ff;
}
.sub-color5 {
  color: #ecd6d6;
}

/* font */
/* Pretendard Variable */
@font-face {
  font-family: "ptd-v";
  font-style: normal;
  font-weight: 400;
  src: url("https://cdn.jsdelivr.net/gh/Project-Noonnu/noonfonts_2107@1.1/Pretendard-Regular.woff")
    format("woff");
}
@font-face {
  font-family: "ptd-v";
  font-style: normal;
  font-weight: 500;
  src: url("https://cdn.jsdelivr.net/gh/Project-Noonnu/noonfonts_2107@1.1/Pretendard-Medium.woff")
    format("woff");
}
@font-face {
  font-family: "ptd-v";
  font-style: normal;
  font-weight: 600;
  src: url("https://cdn.jsdelivr.net/gh/Project-Noonnu/noonfonts_2107@1.1/Pretendard-SemiBold.woff")
    format("woff");
}
@font-face {
  font-family: "ptd-v";
  font-style: normal;
  font-weight: 700;
  src: url("https://cdn.jsdelivr.net/gh/Project-Noonnu/noonfonts_2107@1.1/Pretendard-Bold.woff")
    format("woff");
}

/* loading button */
.loading_wrap {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}

.loading span {
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: gray;
  border-radius: 50%;
  animation: loading 1s 0s linear infinite;
}

.loading span:nth-child(1) {
  animation-delay: 0s;
  background-color: red;
}

.loading span:nth-child(2) {
  animation-delay: 0.2s;
  background-color: orange;
}

.loading span:nth-child(3) {
  animation-delay: 0.4s;
  background-color: yellowgreen;
}

@keyframes loading {
  /*loading이라는 keyframe 애니메이션*/
  0%,                      /* 0, 50, 100은 구간*/
  100% {
    opacity: 0; /* 안보였다가 */
    transform: scale(
      0.5
    ); /*transform의 scale로 요소를 확대 또는 축소할 수 있음*/
  }
  50% {
    opacity: 1; /* 보였다가 */
    transform: scale(1.2); /* 1.2배 */
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/common.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,UAAU;AACV;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,wBAAwB;AAC1B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,SAAS;EACT,6BAA6B;EAC7B,WAAW;AACb;AACA;;;;EAIE,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;EACvB,wCAAwC;AAC1C;AACA;;;EAGE,aAAa;AACf;AACA;;;;EAIE,kDAAkD;EAClD,yDAAiD;EAAjD,iDAAiD;AACnD;AACA;EACE,YAAY;EACZ,wCAAwC;AAC1C;AACA;EACE,eAAe;EACf,wCAAwC;AAC1C;AACA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;AACpB;;AAEA,WAAW;AACX,SAAS;AACT;;;;;;;;;;;;EAYE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,sCAAsC;EACtC,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,UAAU;EACV,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,cAAc;AAChB;AACA;;EAEE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,SAAS;AACX;AACA;;EAEE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,eAAe;AACjB;AACA;;EAEE,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,UAAU;AACV;EACE,WAAW;EACX,YAAY;EACZ,yDAAgE;AAClE;AACA;EACE,WAAW;EACX,YAAY;EACZ,yDAAkE;AACpE;AACA;EACE,WAAW;EACX,YAAY;EACZ,yDAAmE;AACrE;AACA;EACE,aAAa;EACb,cAAc;EACd,yDAAqE;AACvE;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,cAAc;EACd,yDAA+D;AACjE;AACA;EACE,aAAa;EACb,cAAc;EACd,yDAA+D;AACjE;AACA;EACE,aAAa;EACb,cAAc;EACd,yDAA+D;AACjE;AACA;EACE,aAAa;EACb,cAAc;EACd,yDAA8D;AAChE;;AAEA;EACE,aAAa;EACb,cAAc;EACd,yDAAqE;AACvE;AACA;EACE,aAAa;EACb,cAAc;EACd,yDAAqE;AACvE;AACA;EACE,aAAa;EACb,cAAc;EACd,0DAAqE;AACvE;;AAEA,aAAa;AACb;EACE,WAAW;EACX,YAAY;EACZ,0DAAkE;AACpE;AACA;EACE,WAAW;EACX,YAAY;EACZ,0DAA8D;AAChE;AACA,SAAS;AACT;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,0DAAiE;AACnE;AACA;EACE,0DAAiE;AACnE;AACA;EACE,0DAAiE;AACnE;AACA;EACE,0DAAiE;AACnE;AACA;EACE,0DAAiE;AACnE;AACA;EACE,0DAAiE;AACnE;AACA;EACE,0DAAiE;AACnE;AACA;EACE,0DAAiE;AACnE;AACA;EACE,0DAAiE;AACnE;AACA;EACE,0DAAiE;AACnE;AACA;EACE,0DAAiE;AACnE;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,0DAA6E;AAC/E;AACA;EACE,0DAA6E;AAC/E;AACA;EACE,0DAA6E;AAC/E;AACA;EACE,0DAA6E;AAC/E;AACA;EACE,0DAA6E;AAC/E;AACA;EACE,0DAA6E;AAC/E;;AAEA,KAAK;AACL;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,UAAU;EACV,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;;AAEA,QAAQ;AACR;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,wBAAwB;AAC1B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;;AAEA,YAAY;AACZ;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,SAAS;AACT,wBAAwB;AACxB;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB;kBACgB;AAClB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB;kBACgB;AAClB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB;kBACgB;AAClB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB;kBACgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B;;IAEE,UAAU,EAAE,UAAU;IACtB;;KAEC,EAAE,uCAAuC;EAC5C;EACA;IACE,UAAU,EAAE,SAAS;IACrB,qBAAqB,EAAE,SAAS;EAClC;AACF","sourcesContent":["/* v1.0 mobile */\n/* reset */\n* {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  box-sizing: border-box;\n}\nhtml {\n  font-size: 62.5%;\n  line-height: 1;\n  font-family: \"ptd-v\";\n  letter-spacing: -0.03rem;\n}\nbody {\n  font-size: 1.6rem;\n}\nli {\n  list-style: none;\n}\na {\n  color: #000;\n  text-decoration: none;\n}\nbutton {\n  padding: 0;\n  border: 0;\n  background-color: transparent;\n  color: #000;\n}\nbutton,\ninput,\ntextarea,\nselect {\n  font-weight: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  font-family: inherit;\n  letter-spacing: inherit;\n  -webkit-tap-highlight-color: transparent;\n}\ninput:focus,\ntextarea:focus,\nselect:focus {\n  outline: none;\n}\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 100rem transparent inset;\n  transition: background-color 5000s ease-in-out 0s;\n}\ntextarea {\n  resize: none;\n  -webkit-tap-highlight-color: transparent;\n}\nlabel {\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n}\ntable {\n  border-spacing: 0;\n  border-collapse: collapse;\n}\nth,\ntd {\n  position: relative;\n}\n\n/* common */\n/* form */\ninput[type=\"text\"],\ninput[type=\"email\"],\ninput[type=\"password\"],\ninput[type=\"tel\"],\ninput[type=\"tel\"],\ninput[type=\"search\"],\ninput[type=\"datetime-local\"],\ninput[type=\"date\"],\ninput[type=\"month\"],\ninput[type=\"time\"],\ninput[type=\"url\"],\ninput.tf {\n  height: 2.5rem;\n  /* font-weight: 500; */\n  /* font-size: 1.7rem; */\n  color: #000;\n  /* IOS에서 input border-radius, 그림자 해제 */\n  -webkit-appearance: none;\n  -webkit-border-radius: 0;\n}\ninput::placeholder {\n  color: #919191;\n}\ninput:disabled {\n  background-color: #fff;\n  /* IOS에서 input disabled의 기본값 해제 */\n  opacity: 1;\n  -webkit-text-fill-color: #2f2f2f;\n  color: #2f2f2f;\n}\ninput:disabled.type2 {\n  font-weight: 400 !important;\n  color: #919191;\n}\ninput[type=\"button\"],\ninput[type=\"submit\"] {\n  cursor: pointer;\n}\n\ninput[type=\"file\"] {\n  position: absolute;\n  overflow: hidden;\n  width: 0;\n  height: 0;\n  padding: 0;\n  border: 0;\n}\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  cursor: pointer;\n}\ninput[type=\"checkbox\"]:checked,\ninput[type=\"radio\"]:checked {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  cursor: pointer;\n}\nselect {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  cursor: pointer;\n}\n\n/* button */\nbutton {\n  cursor: pointer;\n}\n\n/* icon */\ni {\n  display: inline-block;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n\n/* arrow */\n.ico-up-arr {\n  width: 2rem;\n  height: 2rem;\n  background-image: url(\"/src/assets/images/icon/icon_up_arr.svg\");\n}\n.ico-down-arr {\n  width: 2rem;\n  height: 2rem;\n  background-image: url(\"/src/assets/images/icon/icon_down_arr.svg\");\n}\n.ico-right-arr {\n  width: 2rem;\n  height: 2rem;\n  background-image: url(\"/src/assets/images/icon/icon_right_arr.svg\");\n}\n.ico-right-arr-2 {\n  width: 1.8rem;\n  height: 1.8rem;\n  background-image: url(\"/src/assets/images/icon/icon_right_arr_2.svg\");\n}\n\n/* social join btn */\n.ico-kakao {\n  width: 2.5rem;\n  height: 2.5rem;\n  background-image: url(\"/src/assets/images/icon/icon_kakao.svg\");\n}\n.ico-naver {\n  width: 2.5rem;\n  height: 2.5rem;\n  background-image: url(\"/src/assets/images/icon/icon_naver.svg\");\n}\n.ico-apple {\n  width: 2.5rem;\n  height: 2.5rem;\n  background-image: url(\"/src/assets/images/icon/icon_apple.svg\");\n}\n.ico-user {\n  width: 2.5rem;\n  height: 2.5rem;\n  background-image: url(\"/src/assets/images/icon/icon_user.svg\");\n}\n\n.ico-round-kakao {\n  width: 1.9rem;\n  height: 1.9rem;\n  background-image: url(\"/src/assets/images/icon/icon_round_kakao.svg\");\n}\n.ico-round-naver {\n  width: 1.9rem;\n  height: 1.9rem;\n  background-image: url(\"/src/assets/images/icon/icon_round_naver.svg\");\n}\n.ico-round-apple {\n  width: 1.9rem;\n  height: 1.9rem;\n  background-image: url(\"/src/assets/images/icon/icon_round_apple.svg\");\n}\n\n/* complete */\n.ico-complete {\n  width: 5rem;\n  height: 5rem;\n  background-image: url(\"/src/assets/images/icon/icon_complete.svg\");\n}\n.ico-fail {\n  width: 4rem;\n  height: 4rem;\n  background-image: url(\"/src/assets/images/icon/icon_fail.svg\");\n}\n/* menu */\n.ico-menu {\n  width: 3rem;\n  height: 3rem;\n}\n.menu1-1 .ico-menu {\n  background-image: url(\"/src/assets/images/icon/icon_menu1_1.svg\");\n}\n.menu1-2 .ico-menu {\n  background-image: url(\"/src/assets/images/icon/icon_menu1_2.svg\");\n}\n.menu1-3 .ico-menu {\n  background-image: url(\"/src/assets/images/icon/icon_menu1_3.svg\");\n}\n.menu2-1 .ico-menu {\n  background-image: url(\"/src/assets/images/icon/icon_menu2_1.svg\");\n}\n.menu2-2 .ico-menu {\n  background-image: url(\"/src/assets/images/icon/icon_menu2_2.svg\");\n}\n.menu2-3 .ico-menu {\n  background-image: url(\"/src/assets/images/icon/icon_menu2_3.svg\");\n}\n.menu2-4 .ico-menu {\n  background-image: url(\"/src/assets/images/icon/icon_menu2_4.svg\");\n}\n.menu3-1 .ico-menu {\n  background-image: url(\"/src/assets/images/icon/icon_menu3_1.svg\");\n}\n.menu3-2 .ico-menu {\n  background-image: url(\"/src/assets/images/icon/icon_menu3_2.svg\");\n}\n.menu3-3 .ico-menu {\n  background-image: url(\"/src/assets/images/icon/icon_menu3_3.svg\");\n}\n.menu4-1 .ico-menu {\n  background-image: url(\"/src/assets/images/icon/icon_menu4_1.svg\");\n}\n\n/* community category */\n.ico-community-category {\n  width: 7.5rem;\n  height: 7.5rem;\n}\n.category1 .ico-community-category {\n  background-image: url(\"/src/assets/images/icon/icon_community_category1.png\");\n}\n.category2 .ico-community-category {\n  background-image: url(\"/src/assets/images/icon/icon_community_category2.png\");\n}\n.category3 .ico-community-category {\n  background-image: url(\"/src/assets/images/icon/icon_community_category3.png\");\n}\n.category4 .ico-community-category {\n  background-image: url(\"/src/assets/images/icon/icon_community_category4.png\");\n}\n.category5 .ico-community-category {\n  background-image: url(\"/src/assets/images/icon/icon_community_category5.png\");\n}\n.category6 .ico-community-category {\n  background-image: url(\"/src/assets/images/icon/icon_community_category6.png\");\n}\n\n/*  */\n.sr-only {\n  position: absolute;\n  width: 0.1rem;\n  height: 0.1rem;\n  padding: 0;\n  margin: -0.1rem;\n  border: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  clip-path: polygon(0 0, 0 0, 0 0);\n}\n\n.flex-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.justify-between {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.items-center {\n  display: flex;\n  align-items: center;\n}\n.relative {\n  position: relative;\n}\n\n/* gap */\n.gap0 {\n  gap: 0 !important;\n}\n.gap2 {\n  gap: 0.2rem !important;\n}\n.gap4 {\n  gap: 0.4rem !important;\n}\n.gap5 {\n  gap: 0.5rem !important;\n}\n.gap6 {\n  gap: 0.6rem !important;\n}\n.gap8 {\n  gap: 0.8rem !important;\n}\n.gap10 {\n  gap: 1rem !important;\n}\n.gap12 {\n  gap: 1.2rem !important;\n}\n.gap14 {\n  gap: 1.4rem !important;\n}\n.gap15 {\n  gap: 1.5rem !important;\n}\n.gap16 {\n  gap: 1.6rem !important;\n}\n.gap18 {\n  gap: 1.8rem !important;\n}\n.gap20 {\n  gap: 2rem !important;\n}\n.gap22 {\n  gap: 2.2rem !important;\n}\n.gap24 {\n  gap: 2.4rem !important;\n}\n.gap25 {\n  gap: 2.5rem !important;\n}\n.gap26 {\n  gap: 2.6rem !important;\n}\n.gap28 {\n  gap: 2.8rem !important;\n}\n.gap30 {\n  gap: 3rem !important;\n}\n.gap32 {\n  gap: 3.2rem !important;\n}\n.gap34 {\n  gap: 3.4rem !important;\n}\n.gap35 {\n  gap: 3.5rem !important;\n}\n.gap36 {\n  gap: 3.6rem !important;\n}\n.gap38 {\n  gap: 3.8rem !important;\n}\n.gap40 {\n  gap: 4rem !important;\n}\n.gap42 {\n  gap: 4.2rem !important;\n}\n.gap42 {\n  gap: 4.2rem !important;\n}\n.gap44 {\n  gap: 4.4rem !important;\n}\n.gap45 {\n  gap: 4.5rem !important;\n}\n.gap46 {\n  gap: 4.6rem !important;\n}\n.gap48 {\n  gap: 4.8rem !important;\n}\n.gap50 {\n  gap: 5rem !important;\n}\n.gap52 {\n  gap: 5.2rem !important;\n}\n.gap54 {\n  gap: 5.4rem !important;\n}\n.gap55 {\n  gap: 5.5rem !important;\n}\n.gap56 {\n  gap: 5.6rem !important;\n}\n.gap58 {\n  gap: 5.8rem !important;\n}\n.gap60 {\n  gap: 6rem !important;\n}\n.gap62 {\n  gap: 6.2rem !important;\n}\n.gap64 {\n  gap: 6.4rem !important;\n}\n.gap65 {\n  gap: 6.5rem !important;\n}\n.gap65 {\n  gap: 6.5rem !important;\n}\n.gap66 {\n  gap: 6.6rem !important;\n}\n.gap68 {\n  gap: 6.8rem !important;\n}\n.gap70 {\n  gap: 7rem !important;\n}\n.gap72 {\n  gap: 7.2rem !important;\n}\n.gap74 {\n  gap: 7.4rem !important;\n}\n.gap74 {\n  gap: 7.4rem !important;\n}\n.gap75 {\n  gap: 7.5rem !important;\n}\n.gap76 {\n  gap: 7.6rem !important;\n}\n.gap78 {\n  gap: 7.8rem !important;\n}\n.gap80 {\n  gap: 8rem !important;\n}\n.gap82 {\n  gap: 8.2rem !important;\n}\n.gap84 {\n  gap: 8.4rem !important;\n}\n.gap85 {\n  gap: 8.5rem !important;\n}\n.gap86 {\n  gap: 8.6rem !important;\n}\n.gap88 {\n  gap: 8.8rem !important;\n}\n.gap90 {\n  gap: 9rem !important;\n}\n.gap92 {\n  gap: 9.2rem !important;\n}\n.gap94 {\n  gap: 9.4rem !important;\n}\n.gap95 {\n  gap: 9.5rem !important;\n}\n.gap96 {\n  gap: 9.6rem !important;\n}\n.gap98 {\n  gap: 9.8rem !important;\n}\n.gap100 {\n  gap: 10rem !important;\n}\n\n/* margin */\n.mt0 {\n  margin-top: 0 !important;\n}\n.mt2 {\n  margin-top: 0.2rem !important;\n}\n.mt4 {\n  margin-top: 0.4rem !important;\n}\n.mt5 {\n  margin-top: 0.5rem !important;\n}\n.mt6 {\n  margin-top: 0.6rem !important;\n}\n.mt8 {\n  margin-top: 0.8rem !important;\n}\n.mt10 {\n  margin-top: 1rem !important;\n}\n.mt12 {\n  margin-top: 1.2rem !important;\n}\n.mt14 {\n  margin-top: 1.4rem !important;\n}\n.mt15 {\n  margin-top: 1.5rem !important;\n}\n.mt16 {\n  margin-top: 1.6rem !important;\n}\n.mt18 {\n  margin-top: 1.8rem !important;\n}\n.mt20 {\n  margin-top: 2rem !important;\n}\n.mt22 {\n  margin-top: 2.2rem !important;\n}\n.mt24 {\n  margin-top: 2.4rem !important;\n}\n.mt25 {\n  margin-top: 2.5rem !important;\n}\n.mt26 {\n  margin-top: 2.6rem !important;\n}\n.mt28 {\n  margin-top: 2.8rem !important;\n}\n.mt30 {\n  margin-top: 3rem !important;\n}\n.mt32 {\n  margin-top: 3.2rem !important;\n}\n.mt34 {\n  margin-top: 3.4rem !important;\n}\n.mt35 {\n  margin-top: 3.5rem !important;\n}\n.mt36 {\n  margin-top: 3.6rem !important;\n}\n.mt38 {\n  margin-top: 3.8rem !important;\n}\n.mt40 {\n  margin-top: 4rem !important;\n}\n.mt42 {\n  margin-top: 4.2rem !important;\n}\n.mt42 {\n  margin-top: 4.2rem !important;\n}\n.mt44 {\n  margin-top: 4.4rem !important;\n}\n.mt45 {\n  margin-top: 4.5rem !important;\n}\n.mt46 {\n  margin-top: 4.6rem !important;\n}\n.mt48 {\n  margin-top: 4.8rem !important;\n}\n.mt50 {\n  margin-top: 5rem !important;\n}\n.mt52 {\n  margin-top: 5.2rem !important;\n}\n.mt54 {\n  margin-top: 5.4rem !important;\n}\n.mt55 {\n  margin-top: 5.5rem !important;\n}\n.mt56 {\n  margin-top: 5.6rem !important;\n}\n.mt58 {\n  margin-top: 5.8rem !important;\n}\n.mt60 {\n  margin-top: 6rem !important;\n}\n.mt62 {\n  margin-top: 6.2rem !important;\n}\n.mt64 {\n  margin-top: 6.4rem !important;\n}\n.mt65 {\n  margin-top: 6.5rem !important;\n}\n.mt65 {\n  margin-top: 6.5rem !important;\n}\n.mt66 {\n  margin-top: 6.6rem !important;\n}\n.mt68 {\n  margin-top: 6.8rem !important;\n}\n.mt70 {\n  margin-top: 7rem !important;\n}\n.mt72 {\n  margin-top: 7.2rem !important;\n}\n.mt74 {\n  margin-top: 7.4rem !important;\n}\n.mt74 {\n  margin-top: 7.4rem !important;\n}\n.mt75 {\n  margin-top: 7.5rem !important;\n}\n.mt76 {\n  margin-top: 7.6rem !important;\n}\n.mt78 {\n  margin-top: 7.8rem !important;\n}\n.mt80 {\n  margin-top: 8rem !important;\n}\n.mt82 {\n  margin-top: 8.2rem !important;\n}\n.mt84 {\n  margin-top: 8.4rem !important;\n}\n.mt85 {\n  margin-top: 8.5rem !important;\n}\n.mt86 {\n  margin-top: 8.6rem !important;\n}\n.mt88 {\n  margin-top: 8.8rem !important;\n}\n.mt90 {\n  margin-top: 9rem !important;\n}\n.mt92 {\n  margin-top: 9.2rem !important;\n}\n.mt94 {\n  margin-top: 9.4rem !important;\n}\n.mt95 {\n  margin-top: 9.5rem !important;\n}\n.mt96 {\n  margin-top: 9.6rem !important;\n}\n.mt98 {\n  margin-top: 9.8rem !important;\n}\n.mt100 {\n  margin-top: 10rem !important;\n}\n\n.mb0 {\n  margin-bottom: 0 !important;\n}\n.mb2 {\n  margin-bottom: 0.2rem !important;\n}\n.mb4 {\n  margin-bottom: 0.4rem !important;\n}\n.mb5 {\n  margin-bottom: 0.5rem !important;\n}\n.mb6 {\n  margin-bottom: 0.6rem !important;\n}\n.mb8 {\n  margin-bottom: 0.8rem !important;\n}\n.mb10 {\n  margin-bottom: 1rem !important;\n}\n.mb12 {\n  margin-bottom: 1.2rem !important;\n}\n.mb14 {\n  margin-bottom: 1.4rem !important;\n}\n.mb15 {\n  margin-bottom: 1.5rem !important;\n}\n.mb16 {\n  margin-bottom: 1.6rem !important;\n}\n.mb18 {\n  margin-bottom: 1.8rem !important;\n}\n.mb20 {\n  margin-bottom: 2rem !important;\n}\n.mb22 {\n  margin-bottom: 2.2rem !important;\n}\n.mb24 {\n  margin-bottom: 2.4rem !important;\n}\n.mb25 {\n  margin-bottom: 2.5rem !important;\n}\n.mb26 {\n  margin-bottom: 2.6rem !important;\n}\n.mb28 {\n  margin-bottom: 2.8rem !important;\n}\n.mb30 {\n  margin-bottom: 3rem !important;\n}\n.mb32 {\n  margin-bottom: 3.2rem !important;\n}\n.mb34 {\n  margin-bottom: 3.4rem !important;\n}\n.mb35 {\n  margin-bottom: 3.5rem !important;\n}\n.mb36 {\n  margin-bottom: 3.6rem !important;\n}\n.mb38 {\n  margin-bottom: 3.8rem !important;\n}\n.mb40 {\n  margin-bottom: 4rem !important;\n}\n.mb42 {\n  margin-bottom: 4.2rem !important;\n}\n.mb42 {\n  margin-bottom: 4.2rem !important;\n}\n.mb44 {\n  margin-bottom: 4.4rem !important;\n}\n.mb45 {\n  margin-bottom: 4.5rem !important;\n}\n.mb46 {\n  margin-bottom: 4.6rem !important;\n}\n.mb48 {\n  margin-bottom: 4.8rem !important;\n}\n.mb50 {\n  margin-bottom: 5rem !important;\n}\n.mb52 {\n  margin-bottom: 5.2rem !important;\n}\n.mb54 {\n  margin-bottom: 5.4rem !important;\n}\n.mb55 {\n  margin-bottom: 5.5rem !important;\n}\n.mb56 {\n  margin-bottom: 5.6rem !important;\n}\n.mb58 {\n  margin-bottom: 5.8rem !important;\n}\n.mb60 {\n  margin-bottom: 6rem !important;\n}\n.mb62 {\n  margin-bottom: 6.2rem !important;\n}\n.mb64 {\n  margin-bottom: 6.4rem !important;\n}\n.mb65 {\n  margin-bottom: 6.5rem !important;\n}\n.mb65 {\n  margin-bottom: 6.5rem !important;\n}\n.mb66 {\n  margin-bottom: 6.6rem !important;\n}\n.mb68 {\n  margin-bottom: 6.8rem !important;\n}\n.mb70 {\n  margin-bottom: 7rem !important;\n}\n.mb72 {\n  margin-bottom: 7.2rem !important;\n}\n.mb74 {\n  margin-bottom: 7.4rem !important;\n}\n.mb74 {\n  margin-bottom: 7.4rem !important;\n}\n.mb75 {\n  margin-bottom: 7.5rem !important;\n}\n.mb76 {\n  margin-bottom: 7.6rem !important;\n}\n.mb78 {\n  margin-bottom: 7.8rem !important;\n}\n.mb80 {\n  margin-bottom: 8rem !important;\n}\n.mb82 {\n  margin-bottom: 8.2rem !important;\n}\n.mb84 {\n  margin-bottom: 8.4rem !important;\n}\n.mb85 {\n  margin-bottom: 8.5rem !important;\n}\n.mb86 {\n  margin-bottom: 8.6rem !important;\n}\n.mb88 {\n  margin-bottom: 8.8rem !important;\n}\n.mb90 {\n  margin-bottom: 9rem !important;\n}\n.mb92 {\n  margin-bottom: 9.2rem !important;\n}\n.mb94 {\n  margin-bottom: 9.4rem !important;\n}\n.mb95 {\n  margin-bottom: 9.5rem !important;\n}\n.mb96 {\n  margin-bottom: 9.6rem !important;\n}\n.mb98 {\n  margin-bottom: 9.8rem !important;\n}\n.mb100 {\n  margin-bottom: 10rem !important;\n}\n\n/* padding */\n.p0 {\n  padding: 0 !important;\n}\n\n.pt0 {\n  padding-top: 0 !important;\n}\n.pt2 {\n  padding-top: 0.2rem !important;\n}\n.pt4 {\n  padding-top: 0.4rem !important;\n}\n.pt5 {\n  padding-top: 0.5rem !important;\n}\n.pt6 {\n  padding-top: 0.6rem !important;\n}\n.pt8 {\n  padding-top: 0.8rem !important;\n}\n.pt10 {\n  padding-top: 1rem !important;\n}\n.pt12 {\n  padding-top: 1.2rem !important;\n}\n.pt14 {\n  padding-top: 1.4rem !important;\n}\n.pt15 {\n  padding-top: 1.5rem !important;\n}\n.pt16 {\n  padding-top: 1.6rem !important;\n}\n.pt18 {\n  padding-top: 1.8rem !important;\n}\n.pt20 {\n  padding-top: 2rem !important;\n}\n.pt22 {\n  padding-top: 2.2rem !important;\n}\n.pt24 {\n  padding-top: 2.4rem !important;\n}\n.pt25 {\n  padding-top: 2.5rem !important;\n}\n.pt26 {\n  padding-top: 2.6rem !important;\n}\n.pt28 {\n  padding-top: 2.8rem !important;\n}\n.pt30 {\n  padding-top: 3rem !important;\n}\n.pt32 {\n  padding-top: 3.2rem !important;\n}\n.pt34 {\n  padding-top: 3.4rem !important;\n}\n.pt35 {\n  padding-top: 3.5rem !important;\n}\n.pt36 {\n  padding-top: 3.6rem !important;\n}\n.pt38 {\n  padding-top: 3.8rem !important;\n}\n.pt40 {\n  padding-top: 4rem !important;\n}\n.pt42 {\n  padding-top: 4.2rem !important;\n}\n.pt42 {\n  padding-top: 4.2rem !important;\n}\n.pt44 {\n  padding-top: 4.4rem !important;\n}\n.pt45 {\n  padding-top: 4.5rem !important;\n}\n.pt46 {\n  padding-top: 4.6rem !important;\n}\n.pt48 {\n  padding-top: 4.8rem !important;\n}\n.pt50 {\n  padding-top: 5rem !important;\n}\n.pt52 {\n  padding-top: 5.2rem !important;\n}\n.pt54 {\n  padding-top: 5.4rem !important;\n}\n.pt55 {\n  padding-top: 5.5rem !important;\n}\n.pt56 {\n  padding-top: 5.6rem !important;\n}\n.pt58 {\n  padding-top: 5.8rem !important;\n}\n.pt60 {\n  padding-top: 6rem !important;\n}\n.pt62 {\n  padding-top: 6.2rem !important;\n}\n.pt64 {\n  padding-top: 6.4rem !important;\n}\n.pt65 {\n  padding-top: 6.5rem !important;\n}\n.pt65 {\n  padding-top: 6.5rem !important;\n}\n.pt66 {\n  padding-top: 6.6rem !important;\n}\n.pt68 {\n  padding-top: 6.8rem !important;\n}\n.pt70 {\n  padding-top: 7rem !important;\n}\n.pt72 {\n  padding-top: 7.2rem !important;\n}\n.pt74 {\n  padding-top: 7.4rem !important;\n}\n.pt74 {\n  padding-top: 7.4rem !important;\n}\n.pt75 {\n  padding-top: 7.5rem !important;\n}\n.pt76 {\n  padding-top: 7.6rem !important;\n}\n.pt78 {\n  padding-top: 7.8rem !important;\n}\n.pt80 {\n  padding-top: 8rem !important;\n}\n.pt82 {\n  padding-top: 8.2rem !important;\n}\n.pt84 {\n  padding-top: 8.4rem !important;\n}\n.pt85 {\n  padding-top: 8.5rem !important;\n}\n.pt86 {\n  padding-top: 8.6rem !important;\n}\n.pt88 {\n  padding-top: 8.8rem !important;\n}\n.pt90 {\n  padding-top: 9rem !important;\n}\n.pt92 {\n  padding-top: 9.2rem !important;\n}\n.pt94 {\n  padding-top: 9.4rem !important;\n}\n.pt95 {\n  padding-top: 9.5rem !important;\n}\n.pt96 {\n  padding-top: 9.6rem !important;\n}\n.pt98 {\n  padding-top: 9.8rem !important;\n}\n.pt100 {\n  padding-top: 10rem !important;\n}\n\n.pb0 {\n  padding-bottom: 0 !important;\n}\n.pb2 {\n  padding-bottom: 0.2rem !important;\n}\n.pb4 {\n  padding-bottom: 0.4rem !important;\n}\n.pb5 {\n  padding-bottom: 0.5rem !important;\n}\n.pb6 {\n  padding-bottom: 0.6rem !important;\n}\n.pb8 {\n  padding-bottom: 0.8rem !important;\n}\n.pb10 {\n  padding-bottom: 1rem !important;\n}\n.pb12 {\n  padding-bottom: 1.2rem !important;\n}\n.pb14 {\n  padding-bottom: 1.4rem !important;\n}\n.pb15 {\n  padding-bottom: 1.5rem !important;\n}\n.pb16 {\n  padding-bottom: 1.6rem !important;\n}\n.pb18 {\n  padding-bottom: 1.8rem !important;\n}\n.pb20 {\n  padding-bottom: 2rem !important;\n}\n.pb22 {\n  padding-bottom: 2.2rem !important;\n}\n.pb24 {\n  padding-bottom: 2.4rem !important;\n}\n.pb25 {\n  padding-bottom: 2.5rem !important;\n}\n.pb26 {\n  padding-bottom: 2.6rem !important;\n}\n.pb28 {\n  padding-bottom: 2.8rem !important;\n}\n.pb30 {\n  padding-bottom: 3rem !important;\n}\n.pb32 {\n  padding-bottom: 3.2rem !important;\n}\n.pb34 {\n  padding-bottom: 3.4rem !important;\n}\n.pb35 {\n  padding-bottom: 3.5rem !important;\n}\n.pb36 {\n  padding-bottom: 3.6rem !important;\n}\n.pb38 {\n  padding-bottom: 3.8rem !important;\n}\n.pb40 {\n  padding-bottom: 4rem !important;\n}\n.pb42 {\n  padding-bottom: 4.2rem !important;\n}\n.pb42 {\n  padding-bottom: 4.2rem !important;\n}\n.pb44 {\n  padding-bottom: 4.4rem !important;\n}\n.pb45 {\n  padding-bottom: 4.5rem !important;\n}\n.pb46 {\n  padding-bottom: 4.6rem !important;\n}\n.pb48 {\n  padding-bottom: 4.8rem !important;\n}\n.pb50 {\n  padding-bottom: 5rem !important;\n}\n.pb52 {\n  padding-bottom: 5.2rem !important;\n}\n.pb54 {\n  padding-bottom: 5.4rem !important;\n}\n.pb55 {\n  padding-bottom: 5.5rem !important;\n}\n.pb56 {\n  padding-bottom: 5.6rem !important;\n}\n.pb58 {\n  padding-bottom: 5.8rem !important;\n}\n.pb60 {\n  padding-bottom: 6rem !important;\n}\n.pb62 {\n  padding-bottom: 6.2rem !important;\n}\n.pb64 {\n  padding-bottom: 6.4rem !important;\n}\n.pb65 {\n  padding-bottom: 6.5rem !important;\n}\n.pb65 {\n  padding-bottom: 6.5rem !important;\n}\n.pb66 {\n  padding-bottom: 6.6rem !important;\n}\n.pb68 {\n  padding-bottom: 6.8rem !important;\n}\n.pb70 {\n  padding-bottom: 7rem !important;\n}\n.pb72 {\n  padding-bottom: 7.2rem !important;\n}\n.pb74 {\n  padding-bottom: 7.4rem !important;\n}\n.pb74 {\n  padding-bottom: 7.4rem !important;\n}\n.pb75 {\n  padding-bottom: 7.5rem !important;\n}\n.pb76 {\n  padding-bottom: 7.6rem !important;\n}\n.pb78 {\n  padding-bottom: 7.8rem !important;\n}\n.pb80 {\n  padding-bottom: 8rem !important;\n}\n.pb82 {\n  padding-bottom: 8.2rem !important;\n}\n.pb84 {\n  padding-bottom: 8.4rem !important;\n}\n.pb85 {\n  padding-bottom: 8.5rem !important;\n}\n.pb86 {\n  padding-bottom: 8.6rem !important;\n}\n.pb88 {\n  padding-bottom: 8.8rem !important;\n}\n.pb90 {\n  padding-bottom: 9rem !important;\n}\n.pb92 {\n  padding-bottom: 9.2rem !important;\n}\n.pb94 {\n  padding-bottom: 9.4rem !important;\n}\n.pb95 {\n  padding-bottom: 9.5rem !important;\n}\n.pb96 {\n  padding-bottom: 9.6rem !important;\n}\n.pb98 {\n  padding-bottom: 9.8rem !important;\n}\n.pb100 {\n  padding-bottom: 10rem !important;\n}\n.pb120 {\n  padding-bottom: 12rem !important;\n}\n\n/* heading tag */\nh2 {\n  font-weight: 500;\n  font-size: 2rem;\n  line-height: 1.35;\n}\nh2.type2 {\n  font-size: 1.8rem;\n}\nh3 {\n  font-weight: 400;\n  font-size: 1.6rem;\n}\nh3.type2 {\n  font-weight: 500;\n  font-size: 1.8rem;\n}\nh4 {\n  font-weight: 400;\n  font-size: 1.5rem;\n  color: #555;\n}\n.h2 {\n  font-weight: 500;\n  font-size: 2rem;\n  line-height: 1.35;\n}\n.h3 {\n  font-weight: 500;\n  font-size: 1.8rem;\n}\n.h4 {\n  font-weight: 400;\n  font-size: 1.5rem;\n  color: #555;\n}\n\n/* point color */\n.main-color {\n  color: #00b1d8 !important;\n}\n.sub-color1 {\n  color: #008ead;\n}\n.sub-color2 {\n  color: #93d0de;\n}\n.sub-color3 {\n  color: #8dd9f9;\n}\n.sub-color4 {\n  color: #dbf4ff;\n}\n.sub-color5 {\n  color: #ecd6d6;\n}\n\n/* font */\n/* Pretendard Variable */\n@font-face {\n  font-family: \"ptd-v\";\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"https://cdn.jsdelivr.net/gh/Project-Noonnu/noonfonts_2107@1.1/Pretendard-Regular.woff\")\n    format(\"woff\");\n}\n@font-face {\n  font-family: \"ptd-v\";\n  font-style: normal;\n  font-weight: 500;\n  src: url(\"https://cdn.jsdelivr.net/gh/Project-Noonnu/noonfonts_2107@1.1/Pretendard-Medium.woff\")\n    format(\"woff\");\n}\n@font-face {\n  font-family: \"ptd-v\";\n  font-style: normal;\n  font-weight: 600;\n  src: url(\"https://cdn.jsdelivr.net/gh/Project-Noonnu/noonfonts_2107@1.1/Pretendard-SemiBold.woff\")\n    format(\"woff\");\n}\n@font-face {\n  font-family: \"ptd-v\";\n  font-style: normal;\n  font-weight: 700;\n  src: url(\"https://cdn.jsdelivr.net/gh/Project-Noonnu/noonfonts_2107@1.1/Pretendard-Bold.woff\")\n    format(\"woff\");\n}\n\n/* loading button */\n.loading_wrap {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 999;\n}\n\n.loading span {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  background-color: gray;\n  border-radius: 50%;\n  animation: loading 1s 0s linear infinite;\n}\n\n.loading span:nth-child(1) {\n  animation-delay: 0s;\n  background-color: red;\n}\n\n.loading span:nth-child(2) {\n  animation-delay: 0.2s;\n  background-color: orange;\n}\n\n.loading span:nth-child(3) {\n  animation-delay: 0.4s;\n  background-color: yellowgreen;\n}\n\n@keyframes loading {\n  /*loading이라는 keyframe 애니메이션*/\n  0%,                      /* 0, 50, 100은 구간*/\n  100% {\n    opacity: 0; /* 안보였다가 */\n    transform: scale(\n      0.5\n    ); /*transform의 scale로 요소를 확대 또는 축소할 수 있음*/\n  }\n  50% {\n    opacity: 1; /* 보였다가 */\n    transform: scale(1.2); /* 1.2배 */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
